import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { MapComponent } from './map/map.component';
import { createCustomElement } from '@angular/elements';
import { AgmCoreModule } from '@agm/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmDirectionModule } from 'agm-direction';
import {MarkerInfoComponent} from './map/components/marker-info/marker-info.component';
import { FormsModule } from '@angular/forms';
import { CartesianoComponent } from './cartesiano/cartesiano.component';
@NgModule({
  declarations: [AppComponent, MapComponent, MarkerInfoComponent, CartesianoComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAOKuUE1NtcSTVoUdHKjTh2Z0Dj4-XrmL0',
      libraries: ['places'],
    }),
    AgmDirectionModule,
    BrowserAnimationsModule,
  ],
  providers: [],
  bootstrap: [],
  entryComponents: [MapComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    const el = createCustomElement(MapComponent, { injector });
    customElements.define('widget-map', el);
  }
  ngDoBootstrap() {}
}
